import React from 'react';
import moment from 'moment';

import '../styles/ProjectTimeline.css';

const ProjectTimeline = ({ projects }) => {
  // 프로젝트가 없거나 배열이 비어있을 경우 렌더링하지 않음
  if (!projects || projects.length === 0) {
    return (
      <div className="text-center p-5">진행중인 프로젝트가 없습니다.</div>
    );
  }

  // 전체 프로젝트 기간을 기반으로 타임라인의 시작과 끝을 동적으로 계산
  const allDates = projects.flatMap(p => [moment(p.startDate), moment(p.endDate)]);
  const minDate = moment.min(allDates);
  const maxDate = moment.max(allDates);

  const timelineStart = minDate.clone().startOf('year');
  const timelineEnd = maxDate.clone().endOf('year');
  const totalDaysInTimeline = Math.max(1, timelineEnd.diff(timelineStart, 'days')); // 0일 이하 방지

  const getPosition = (date) => {
    const diff = moment(date).diff(timelineStart, 'days');
    return (diff / totalDaysInTimeline) * 100;
  };

  const getWidth = (startDate, endDate) => {
    const diff = moment(endDate).diff(moment(startDate), 'days');
    return (diff / totalDaysInTimeline) * 100;
  };

  // 타임라인 기간 내의 모든 월에 대한 마커와 라벨 생성
  const monthMarkers = [];
  const monthLabels = [];
  let currentMonth = timelineStart.clone();

  while (currentMonth.isBefore(timelineEnd)) {
    const position = getPosition(currentMonth);
    monthMarkers.push(<div key={`line-${currentMonth.format('YYYY-MM')}`} className="month-marker" style={{ left: `${position}%` }} />);

    const middleOfMonth = currentMonth.clone().add(currentMonth.daysInMonth() / 2, 'days');
    const labelPosition = getPosition(middleOfMonth);
    monthLabels.push(
      <span
        key={`label-${currentMonth.format('YYYY-MM')}`}
        className="month-label"
        style={{
          position: 'absolute',
          left: `${labelPosition}%`,
          transform: 'translateX(-50%)',
        }}
      >
        {currentMonth.format('YY/MM')}
      </span>
    );
    currentMonth.add(1, 'month');
  }

  const todayPosition = getPosition(moment());

  // 타임라인 콘텐츠의 동적 너비 계산 (1일당 2px, 최소 100%)
  const contentWidth = Math.max(totalDaysInTimeline * 2, 100);

  return (
    <div className="timeline-container">
      <div className="timeline-content" style={{ width: `${contentWidth}px` }}>
        <div className="timeline-header">
          {monthMarkers}
          {monthLabels}
        </div>
        <div className="timeline-body">
          {projects.map((project) => {
            const start = getPosition(project.startDate);
            const width = getWidth(project.startDate, project.endDate);

            return (
              <div key={project.projectId} className="project-bar-wrapper">
                <div
                  style={{ left: `${start}%`, width: `${width}%` }}
                  className="project-progress-bar"
                  title={`${project.projectName} (${moment(project.startDate).format('YY/MM/DD')}~${moment(project.endDate).format('YY/MM/DD')})`}
                >
                  {project.projectName} ({moment(project.startDate).format('YY/MM/DD')}~{moment(project.endDate).format('YY/MM/DD')})
                </div>
              </div>
            );
          })}
          {todayPosition >= 0 && todayPosition <= 100 && (
            <div className="today-marker" style={{ left: `${todayPosition}%` }}></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectTimeline;